import { ContextMenuAction, ContextMenuActionType } from "../action-types";
import { ADJUST_TRAJECTORY_ACTION } from "./adjust-trajectory-action";
import { OPEN_ALIGN_WIZARD_ACTION } from "./align-actions";
import { ASSIGN_TAGS_ACTION } from "./assign-tags-action";
import { COPY_AS_LOCATION_MARKER_ACTION } from "./copy-as-location-marker-action";
import { DELETE_ACTION } from "./delete-action";
import { DELETE_VIDEO_RECORDING_ACTION } from "./delete-video-recording-action";
import {
  DOWNLOAD_ACTION,
  DOWNLOAD_GAUSSIAN_SPLATS_ACTION,
  DOWNLOAD_IMAGE_ACTION,
  DOWNLOAD_VIDEO_WALK_ACTION,
} from "./download-action";
import { EDIT_DATE_ACTION } from "./edit-date-action";
import {
  DUPLICATE_SHEET_ACTION,
  DUPLICATE_SHEET_WITH_MARKERS_ACTION,
} from "./duplicate-sheet/duplicate-sheet-action";
import { DUPLICATE_SHEET_MENU_ACTION } from "./duplicate-sheet/duplicate-sheet-menu";
import { EDIT_ELEMENT_ACTION } from "./edit-element-action";
import { EDIT_NAME_ACTION } from "./edit-name-action";
import { EDIT_WAYPOINT_COLOR_ACTION } from "./edit-waypoint-color-action";
import { EDIT_WAYPOINT_NAME_ACTION } from "./edit-waypoint-name-action";
import { ENABLE_EDIT_WAYPOINTS_ACTION } from "./enable-edit-waypoints-action";
import { GENERATE_FLOORPLAN } from "./generate-floor-plan/generate-floorplan";
import { MARK_SHEET_AS_ALIGNED_ACTION } from "./mark-sheet-as-aligned";
import { MOVE_DATA_SESSION_ACTION } from "./move-data-session-action";
import { MOVE_TIME_POINT_ACTION } from "./move-time-point-action";
import { MOVE_WAYPOINT_ACTION } from "./move-waypoint-action";
import { RESET_CLOUD_POSITION_ACTION } from "./reset-cloud-position";
import { SCALE_FLOOR_ACTION } from "./scale-floor-action";
import { SCANS_EXPORT } from "./scans-export-action";
import { SET_AS_GEO_REFERENCED_ACTION } from "./set-as-geo-referenced";
import { ADD_DATA_ACTION } from "./upload-action";
import { UPLOAD_GAUSSIAN_SPLATS } from "./upload_gaussian_splats";

/** Static actions to reuse inside context menus.  */
export const ACTIONS: Readonly<
  Record<ContextMenuActionType, ContextMenuAction>
> = {
  [ContextMenuActionType.addData]: ADD_DATA_ACTION,
  [ContextMenuActionType.adjustTrajectory]: ADJUST_TRAJECTORY_ACTION,
  [ContextMenuActionType.assignTags]: ASSIGN_TAGS_ACTION,
  [ContextMenuActionType.copyAsLocationMarker]: COPY_AS_LOCATION_MARKER_ACTION,
  [ContextMenuActionType.delete]: DELETE_ACTION,
  [ContextMenuActionType.deleteVideoRecording]: DELETE_VIDEO_RECORDING_ACTION,
  [ContextMenuActionType.download]: DOWNLOAD_ACTION,
  [ContextMenuActionType.downloadGaussianSplats]:
    DOWNLOAD_GAUSSIAN_SPLATS_ACTION,
  [ContextMenuActionType.downloadImage]: DOWNLOAD_IMAGE_ACTION,
  [ContextMenuActionType.downloadVideoWalk]: DOWNLOAD_VIDEO_WALK_ACTION,
  [ContextMenuActionType.duplicate]: DUPLICATE_SHEET_MENU_ACTION,
  [ContextMenuActionType.duplicateSheet]: DUPLICATE_SHEET_ACTION,
  [ContextMenuActionType.duplicateSheetWithMarkers]:
    DUPLICATE_SHEET_WITH_MARKERS_ACTION,
  [ContextMenuActionType.editDate]: EDIT_DATE_ACTION,
  [ContextMenuActionType.editElement]: EDIT_ELEMENT_ACTION,
  [ContextMenuActionType.editName]: EDIT_NAME_ACTION,
  [ContextMenuActionType.editWaypointColor]: EDIT_WAYPOINT_COLOR_ACTION,
  [ContextMenuActionType.editWaypointName]: EDIT_WAYPOINT_NAME_ACTION,
  [ContextMenuActionType.enableEditWaypoints]: ENABLE_EDIT_WAYPOINTS_ACTION,
  [ContextMenuActionType.generateFloorplan]: GENERATE_FLOORPLAN,
  [ContextMenuActionType.markSheetAsAligned]: MARK_SHEET_AS_ALIGNED_ACTION,
  [ContextMenuActionType.moveDataSession]: MOVE_DATA_SESSION_ACTION,
  [ContextMenuActionType.moveTimePoint]: MOVE_TIME_POINT_ACTION,
  [ContextMenuActionType.moveWaypointToOtherArea]: MOVE_WAYPOINT_ACTION,
  [ContextMenuActionType.openAlignmentWizard]: OPEN_ALIGN_WIZARD_ACTION,
  [ContextMenuActionType.resetCloudPosition]: RESET_CLOUD_POSITION_ACTION,
  [ContextMenuActionType.scaleFloor]: SCALE_FLOOR_ACTION,
  [ContextMenuActionType.scansExport]: SCANS_EXPORT,
  [ContextMenuActionType.setCloudAsGeoReferenced]: SET_AS_GEO_REFERENCED_ACTION,
  [ContextMenuActionType.uploadGaussianSplats]: UPLOAD_GAUSSIAN_SPLATS,
};
